import hamsClient from 'modules/hams';

export default async (cartId: string, promoCode: string) => {
  const r = await hamsClient.post(`/1.0/public/order/cart/${cartId}/promotioncode/${promoCode}`);
  return r.data;
};
